module.exports = __webpack_public_path__ + "img/cream-reuzel-blue-113.b5fdace9.jpg";